import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';

import OneVideo from '@/modules/module-oneVideo';

import '../../styles/pages/about.scss';

export default Backbone.View.extend({

    initialize: function(opts){

        console.log('init about page');

        var self = this;
        self.$content = self.$el;
        self.$moduleD = self.$content.find('.about-module-d');
        self.$moduleE = self.$content.find('.about-module-e');
        self.$moduleF = self.$content.find('.about-module-f');

        self.$moduleD.length > 0 && _.each(self.$moduleD, (module) => {
            self.moduleD($(module));
        })

        self.$moduleE.length > 0 && _.each(self.$moduleE, (module) => {
            self.moduleE($(module));
        })

        self.$moduleF.length > 0 && _.each(self.$moduleF, (module) => {
            self.moduleF($(module));
        })
    },

    events: {

    },

    moduleD: function($module){
        const self = this
        const sectionId = $module.attr(`id`)
        const $container = $module.find(`.blocks-container .inner-wrapper`)
        const $blocks = $module.find(`.block-container`)
        const $filterWrapper = $module.find(`.filters`)
        const $filterInnerWrapper = $module.find(`.filters .inner-wrapper`)
        const $filters = $module.find(`.filters button`)
        const $filterIndicator = $module.find(`.indicator`)

        // Set the indicator width
        if (window.innerWidth < ORW.responsiveSizes.medium) {
            const filterWidth = $filters.first().width()
            $filterIndicator.css(`width`, `${filterWidth}px`)
        }

        // For the indicator
        const offsetValue_v = (42-25)/2;

        const navActionEventKey = `click #${sectionId} .filters button`
        self.events[navActionEventKey] = e => {
            const $curr = $(e.currentTarget)

            if ($curr.hasClass(`active`)) return

            console.log(`Go to: ${$curr.data('filter')}`);

            if ($curr.data('filter')) {
                const targetBlockId = $curr.data('filter')

                if (window.innerWidth < ORW.responsiveSizes.medium) {
                const filterWidth = $curr.width()
                const $indicator = $module.find(`.indicator`)
                $indicator.css(`width`, `${filterWidth}px`)
            }

                const $targetBlock = $module.find(`.block-container[data-filter="${targetBlockId}"]`)
                const targetIndex = parseInt($blocks.index($targetBlock[0]))

                // console.log(targetIndex);
                let indicatorTop = `${ targetIndex / $blocks.length * 100 }%`
                let relativeX = $curr.offset().left - $filterInnerWrapper.offset().left
                if (targetIndex != 0 && targetIndex != ($filters.length - 1)) {
                    indicatorTop = `calc(${ targetIndex / $blocks.length * 100 }% + ${offsetValue_v}px)`
                } else if (targetIndex == ($filters.length - 1)) {
                    indicatorTop = `calc(${ targetIndex / $blocks.length * 100 }% + ${offsetValue_v*2}px)`
                }

                $blocks.removeClass(`is-active`)
                $filters.removeClass(`active`)

                $container.css(`transform`, `translateX(-${ targetIndex / $blocks.length * 100 }%)`)
                $filterIndicator.css(`top`, `${ indicatorTop }`)
                $filterIndicator.css(`left`, `${ relativeX }px`)

                $targetBlock.addClass(`is-active`)
                $curr.addClass(`active`)
            }

        }
        self.delegateEvents();
    },

    moduleE: function($module){
        var self = this;
        var $videos = $module.find('.video-wrapper');

        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: false
        });
    },

    moduleF: function($module){
        var self = this;
        var $productSlider = $module.find('.product-slider.slick');
        var $editorialSlider = $module.find('.editorial-slider.slick');
        var $editorialTitleSlider = $module.find('.editorial-title-slider.slick');

        $productSlider.slick({
            dots: false,
            infinite: true,
            speed: 600,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2,
            arrows: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: ORW.responsiveSizes.medium,
                    settings: {
                        centerPadding: '80px',
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: ORW.responsiveSizes.large,
                    settings: {
                        centerPadding: '100px',
                        slidesToShow: 5
                    }
                }
            ]
        });

        // var $scrollableProducts = self.$moduleB.find('.scrollable');
        // OneCustomScroll.init({
        //     el: $scrollableProducts[0], // HTML object (required), not a jQuery object,
        //     margin: 40 // Number (optional), margin off of the containers bounds.
        // });
        if ($editorialSlider.length && $editorialTitleSlider.length) {
            $editorialSlider.slick({
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: false,
                mobileFirst: true,
                asNavFor: $editorialTitleSlider
            });

            $editorialTitleSlider.slick({
                dots: false,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: false,
                mobileFirst: true,
                asNavFor: $editorialSlider
            });
        }
    },

    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },

    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },

    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});